import { EntityWord, phraseApi } from '@/axios/company';
import { openDeleteModal } from '@/components/Modal/common';
import { useRequest, useSetState } from 'ahooks';
import { Button, Flex, Input, message, Modal, Space, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useRef, useState } from 'react';
import { openBatchAddWordsModal } from '../SearchWord';

const PhraseTable = ({ recordId }: { recordId: string }) => {
  const [params, setParams] = useSetState({
    pageIndex: 1,
    pageSize: 10,
    recordId: recordId,
  });
  const { data, loading, runAsync } = useRequest(
    () => {
      return phraseApi.getEntities(params);
    },
    {
      refreshDeps: [params],
    }
  );
  const [editingRowId, setEditingRowId] = useState<string | null>(null);
  const [editingWord, setEditingWord] = useState<string>('');
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  // const [batchMode, setBatchMode] = useState(false);
  const batchMode = !!selectedRowKeys.length;
  // 批量删除
  const handleBatchDelete = async () => {
    if (selectedRowKeys.length === 0) {
      message.warning('请先选择要删除的词条');
      return;
    }
    openDeleteModal(
      {
        content: `确认删除选中的${selectedRowKeys.length}个词条吗？`,
        api: () =>
          phraseApi.update({
            deleteIds: selectedRowKeys as string[],
            recordId,
          }),
      },
      {
        title: '删除词组',
      },
      () => {
        setSelectedRowKeys([]);
        setParams({ pageIndex: 1 });
      }
    );
  };

  // 批量新增
  const handleBatchAdd = async () => {};

  const columns: ColumnsType<EntityWord> = [
    // {
    //   title: 'ID',
    //   dataIndex: 'id',
    // },
    {
      title: '词组',
      dataIndex: 'word',
      render: (text: string, record: EntityWord) => {
        if (editingRowId === record.id) {
          return (
            <Input
              value={editingWord}
              onChange={(e) => setEditingWord(e.target.value)}
              style={{ width: '100%' }}
              onPressEnter={async () => {
                if (!editingWord.trim()) {
                  message.warning('词组不能为空');
                  return;
                }
                await phraseApi.update({
                  modifyWords: [{ id: record.id, word: editingWord }],
                  recordId: recordId,
                });
                setEditingRowId(null);
                runAsync();
              }}
              autoFocus
            />
          );
        }
        return text;
      },
    },
    {
      title: '操作',
      width: 100,
      render: (_, record) => {
        if (editingRowId === record.id) {
          return (
            <Space>
              <a
                onClick={async () => {
                  if (!editingWord.trim()) {
                    message.warning('词组不能为空');
                    return;
                  }
                  await phraseApi.update({
                    modifyWords: [{ id: record.id, word: editingWord }],
                    recordId: recordId,
                  });
                  setEditingRowId(null);
                  runAsync();
                }}
              >
                保存
              </a>
              <a
                onClick={() => {
                  setEditingRowId(null);
                }}
              >
                取消
              </a>
            </Space>
          );
        }
        return (
          <Space>
            <a
              onClick={() => {
                setEditingRowId(record.id);
                setEditingWord(record.word);
              }}
            >
              编辑
            </a>
            <a
              onClick={() => {
                openDeleteModal(
                  {
                    content: `确认删除该词组吗？`,
                    api: () =>
                      phraseApi.update({
                        deleteIds: [record.id],
                        recordId,
                      }),
                  },
                  {
                    title: '删除词组',
                  },
                  () => setParams({ ...params })
                );
              }}
            >
              删除
            </a>
          </Space>
        );
      },
    },
  ];
  return (
    <div>
      <Flex justify="space-between" style={{ marginBottom: 16 }}>
        <Flex gap={8} align="center">
          <Button danger onClick={handleBatchDelete} disabled={!batchMode} style={{ marginRight: 8 }}>
            批量删除({selectedRowKeys.length})
          </Button>
        </Flex>
        <Button
          type="link"
          onClick={() => {
            openBatchAddWordsModal(undefined, undefined, async (res) => {
              await phraseApi.update({ appendWords: res, recordId });
              runAsync();
              message.success('批量新增成功');
            });
          }}
        >
          复制批量添加
        </Button>
      </Flex>
      <Table
        columns={columns}
        {...(selectedRowKeys
          ? {
              rowSelection: {
                selectedRowKeys,
                onChange: setSelectedRowKeys,
                preserveSelectedRowKeys: true,
              },
            }
          : {})}
        pagination={{
          showSizeChanger: true,
          current: params.pageIndex,
          pageSize: params.pageSize,
          total: data?.total || 0,
          onChange: (page, pageSize) => {
            setParams({ pageIndex: page, pageSize: pageSize });
          },
        }}
        dataSource={data?.records || []}
        loading={loading}
        rowKey="id"
      />
    </div>
  );
};
export default PhraseTable;
